export default __webpack_public_path__ + "static/media/Eina01-SemiBold.d5d9ec80.ttf";